import create from 'zustand';
import { CustomizationParams, ViewerStateInterface } from '../core';

interface IViewerStateContext {
  viewerState: ViewerStateInterface;
  setViewerState: (viewerState: ViewerStateInterface) => void;
}

export const useViewerState = create<IViewerStateContext>()((set) => ({
  viewerState: {
    groupId: null,
    attributeId: null,
    stepId: null,
    price: 0,
    current_filtered_group: null,
    openedAttributes: [],
  },
  setViewerState: (newViewerState: ViewerStateInterface) => set({ viewerState: newViewerState }),
}));

type CustomizationParamsType = CustomizationParams | null;

interface ICustomizationParamsContext {
  customizationParams: CustomizationParamsType;
  setCustomizationParams: (newParams: CustomizationParamsType) => void;
}

export const useCustomizationParams = create<ICustomizationParamsContext>()((set) => ({
  customizationParams: null,
  setCustomizationParams: (newParams: CustomizationParamsType) => set({ customizationParams: newParams }),
}));

export type AttributeType = {
  value: string | number | null;
  option: {
    value: string | number | null;
    code: string | number | null;
  };
};

export type GroupFilteredType = string[] | number[] | null;

interface IAdditionalProps {
  modelCode: string | undefined;
  name: string | undefined;
  groups: Record<string, GroupFilteredType>;
  attributes: Record<string, AttributeType>;
  descriptionFieldValue?: string;
  defaultLang?: object;
}

interface IAdditionalPropsContext {
  additionalProps: IAdditionalProps;
  setAdditionalProps: (additionalProps: IAdditionalProps) => void;
}

export const additionalPropsContext = create<IAdditionalPropsContext>()((set) => ({
  additionalProps: {
    modelCode: undefined,
    name: '',
    groups: {},
    attributes: {},
  },
  setAdditionalProps: (newParams: IAdditionalProps) => set({ additionalProps: newParams }),
}));
